module.exports = __webpack_public_path__ + "static/media/PlutoRegular.de537329.otf";